import { useTranslation } from 'react-i18next';

export function UniqueSection() {
  const { t } = useTranslation();

  const features = [
    {
      icon: 'ri-brain-line',
      title: t('about.unique.features.0.title'),
      description: t('about.unique.features.0.description'),
    },
    {
      icon: 'ri-line-chart-line',
      title: t('about.unique.features.1.title'),
      description: t('about.unique.features.1.description'),
    },
    {
      icon: 'ri-refresh-line',
      title: t('about.unique.features.2.title'),
      description: t('about.unique.features.2.description'),
    },
    {
      icon: 'ri-chat-4-line',
      title: t('about.unique.features.3.title'),
      description: t('about.unique.features.3.description'),
    },
    {
      icon: 'ri-shopping-cart-line',
      title: t('about.unique.features.4.title'),
      description: t('about.unique.features.4.description'),
    },
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-black">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
            {t('about.unique.title')}
          </h2>
          <p className="text-yellow-400 text-xl sm:text-2xl font-semibold">
            {t('about.unique.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-12">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-gray-800 rounded-2xl border border-gray-700 p-8 hover:border-yellow-400 hover:scale-105 transition-ball duration-300 shadow-xl"
            >
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <div className="w-14 h-14 flex items-center justify-center bg-yellow-400/10 rounded-xl">
                    <i className={`${feature.icon} text-3xl text-yellow-400`}></i>
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-white mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-gray-400 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <p className="text-gray-300 text-lg sm:text-xl leading-relaxed max-w-4xl mx-auto">
            {t('about.unique.closing')}
          </p>
        </div>
      </div>
    </section>
  );
}
